export default __webpack_public_path__ + "static/media/portait.f4351b42.PNG";